export const DETAILS = 'DETAILS';
export const DETAILS_TITLE = `${DETAILS}_TITLE`;
